import { motion } from 'framer-motion';
import { Box, Typography } from '@mui/joy';

const initials = (item) => {
    const t = (item?.title || '').trim();
    return t ? t[0].toUpperCase() : '•';
};

export function StoryAvatar({ item, size, onClick }) {
    const seen = !!item?.view_state?.is_completed;
    const accent = item?.accent_color || '#6366f1';
    const img = item?.cover_url || null;
    const ring = seen
        ? 'linear-gradient(#cfcfcf,#cfcfcf)'
        : `linear-gradient(45deg, ${accent}, #f9508a 55%, #ffd200)`;

    return (
        <Box onClick={onClick} sx={{ flex: '0 0 auto', cursor: 'pointer' }}>
            <Box sx={{
                width: size + 6, height: size + 6, borderRadius: '50%', p: '2px',
                background: ring, transition: 'transform .15s',
                '&:active': { transform: 'scale(0.92)' },
            }}>
                <Box sx={{
                    width: size, height: size, borderRadius: '50%',
                    border: '2px solid #fff', overflow: 'hidden',
                    background: img ? `center/cover no-repeat url(${img})` : accent,
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                }}>
                    {!img && (
                        <Typography sx={{ color: '#fff', fontWeight: 800, fontSize: size * 0.4, lineHeight: 1 }}>
                            {initials(item)}
                        </Typography>
                    )}
                </Box>
            </Box>
        </Box>
    );
}

// Компактная стопка для строки шапки (когда лента уехала под шапку).
export function StoriesInline({ items, onOpen, onExpand }) {
    if (!items?.length) return null;
    return (
        <motion.div
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            exit={{ opacity: 0, scale: 0.8 }}
            transition={{ duration: 0.18 }}
            onClick={onExpand}
            style={{ display: 'flex', alignItems: 'center', gap: 6, cursor: 'pointer' }}
        >
            <Box sx={{ display: 'flex' }}>
                {items.slice(0, 3).map((it, i) => (
                    <Box key={it.id} sx={{ ml: i === 0 ? 0 : '-10px', zIndex: 3 - i }}>
                        <StoryAvatar item={it} size={28} onClick={(e) => { e.stopPropagation(); onOpen(i); }} />
                    </Box>
                ))}
            </Box>
        </motion.div>
    );
}

// Полный ряд под шапкой — обычный блок (уезжает при скролле сам).
export function StoriesRow({ items, onOpen }) {
    if (!items?.length) return null;
    return (
        <Box sx={{
            display: 'flex', gap: 1, overflowX: 'auto', px: 1.5, py: 1.25,
            '::-webkit-scrollbar': { display: 'none' }, scrollbarWidth: 'none',
        }}>
            {items.map((it, i) => (
                <Box key={it.id} sx={{ textAlign: 'center', width: 58, flex: '0 0 auto' }}>
                    <StoryAvatar item={it} size={48} onClick={() => onOpen(i)} />
                    <Typography level="body-xs" noWrap sx={{ maxWidth: 54, mx: 'auto', color: 'text.secondary', mt: 0.25 }}>
                        {it.title}
                    </Typography>
                </Box>
            ))}
        </Box>
    );
}